/**
 * Silva City — boundary polygon coordinates extracted from the client-supplied
 * KML file (66 acres project, ~37 vertices).
 *
 * KML format is (longitude, latitude, altitude) — we expose them as
 * [latitude, longitude] pairs because Leaflet uses [lat, lng] order.
 */

export const SILVA_CITY_POLYGON = [
  [18.41253755075369, 74.32530427584251],
  [18.41249797512648, 74.32507172907854],
  [18.41243399784199, 74.32496197476331],
  [18.41231635834937, 74.32488814480415],
  [18.41216101280307, 74.32479256406566],
  [18.41199191013529, 74.32460721556737],
  [18.41187277512199, 74.32387474366598],
  [18.4118535238545, 74.32335338557272],
  [18.41186550694803, 74.32325043886578],
  [18.41252431636869, 74.32323767677012],
  [18.41289379503043, 74.32318952028731],
  [18.41308475218364, 74.32262576611737],
  [18.4131348053509, 74.32210842708255],
  [18.41311932714341, 74.32150029452551],
  [18.41319742445253, 74.3206257147983],
  [18.41304671744153, 74.31966299521214],
  [18.41253727053096, 74.31951780968694],
  [18.41136242365117, 74.31915684915352],
  [18.40977144359911, 74.31887716799316],
  [18.40881220044405, 74.31908204065527],
  [18.40810095831419, 74.31974275733165],
  [18.40769114838888, 74.32089282739747],
  [18.40765086602213, 74.32276479916871],
  [18.4080187711488, 74.32313792514924],
  [18.4087828079206, 74.32358640978241],
  [18.4091678199559, 74.32351298924166],
  [18.41165839810778, 74.32329027295698],
  [18.41168098937362, 74.32341495857457],
  [18.41171359342725, 74.32378638387223],
  [18.41179312989885, 74.32423059186402],
  [18.41184708808813, 74.32455007159388],
  [18.41193818084001, 74.32481412312504],
  [18.4121391059314, 74.32498505140394],
  [18.4123576271167, 74.32502854995886],
  [18.41242162637176, 74.32510805128317],
  [18.41244029522462, 74.3252600056995],
  [18.41245015959567, 74.32534875612006],
  [18.41253755075369, 74.32530427584251],
];

/** Approximate site centroid (used as the LookAt for the embedded map). */
export const SILVA_CITY_CENTROID = [18.41077461298554, 74.32779851872215];

/** Project headline pin location (from the user's primary KML LookAt). */
export const SILVA_CITY_PIN = [18.4125, 74.325306];

/** Default zoom level when the map first renders. */
export const SILVA_CITY_DEFAULT_ZOOM = 15;

/** Bounds covering the entire polygon (south-west, north-east). */
export const SILVA_CITY_BOUNDS = [
  [
    Math.min(...SILVA_CITY_POLYGON.map((p) => p[0])),
    Math.min(...SILVA_CITY_POLYGON.map((p) => p[1])),
  ],
  [
    Math.max(...SILVA_CITY_POLYGON.map((p) => p[0])),
    Math.max(...SILVA_CITY_POLYGON.map((p) => p[1])),
  ],
];
